import { gql, TypedDocumentNode } from '@apollo/client'

import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { AdUnitBidderDTO } from 'features/globalSetup/api/types/adUnitBidderDTO'

export const AD_UNIT_BIDDER_FRAGMENT: TypedDocumentNode<AdUnitBidderDTO> = gql`
  ${ALERT_FRAGMENT}

  fragment AdUnitBidderFragment on AdUnitBidder {
    adUnit {
      divId
      id
      path
    }
    csEnabled
    csParams
    fieldAlerts {
      ...AlertFragment
    }
    id
    s2sEnabled
    s2sParams
    updatedAt
  }
`
